import { z } from "zod";
import "../../../assets/css/adminPages/home/latestNews.scss";
import PageLoader from "../../../components/pageLoader";
import useLatestNews from "../../../hooks/public/useLatestNews";
import LatestNewsAddModal from "../sections/components/LatestNewsAddModal";
import LatestNewsCard from "../sections/components/LatestNewsCard";

const schema = z.object({
  titleEn: z
    .string()
    .refine((value) => value.trim().length >= 10, {
      message: "Minimum Length 10",
    })
    .refine((value) => value.trim().length <= 300, {
      message: "Maximum Length 300",
    }),
  newsLink: z
    .string()
    .min(1, { message: "Invalid URL" })
    .url({ message: "Invalid URL" }),
});

const LatestNewsUpdate = () => {
  const { data, isLoading, error, create, update, remove } = useLatestNews();

  if (error) return null;
  return (
    <section className="latest-news-section">
      {isLoading && <PageLoader />}
      <div className="custom-container">
        <div className="content-section">
          <h1 className="page-title">Latest News</h1>
          <div className="content-body">
            <LatestNewsAddModal schema={schema} create={create} />
            <div className="row">
              {data.map((news) => (
                <div key={news.id} className="col-xl-6">
                  <LatestNewsCard
                    schema={schema}
                    news={news}
                    onUpdate={update}
                    onDelete={remove}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestNewsUpdate;
